
import '../style.css';
import Carousel from './carousel'
import GuanteoCard from './GuanteoCard.jsx'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { useState } from 'react';
import MayoristaModal from './MayoristaModal';
import FaqSection from './FaqSection';
import { FaYoutube, FaInstagram, FaGlobe } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';


function Index() {

  const { i18n } = useTranslation();
  const { t } = useTranslation();

const [showModal, setShowModal] = useState(false);
   
     return ( 
       <div className="indexprincipal">


        <div className="top-banner d-flex justify-content-between align-items-center px-3 py-2">
          {/* Imagen a la izquierda */}
          <div className="banner-image">
            <img src="pez2.png" alt="Personaje Guanteo" className="img-fluid" />
             <img src="pez4.png" alt="Personaje Guanteo" className="img-fluid" />
          </div>

          {/* Título del juego */}
          <div className="banner-title text-center flex-grow-1">
            <img src="Logo-cardumenes-blanco.png" alt="Personaje Guanteo" className="img-fluid" />
          </div>

          {/* Logo editorial a la derecha */}
          <div className="banner-logo">
            <img src="pez1.png" alt="Personaje Guanteo" className="img-fluid" />
             <img src="pez3.png" alt="Personaje Guanteo" className="img-fluid" />
          </div>
        </div>
       {/* --- Pestaña de Idiomas Fija --- */}
    <div className="lang-selector-fixed">
      <button 
        className={`lang-btn ${i18n.language === 'es' ? 'active' : ''}`}
        onClick={() => i18n.changeLanguage('es')}
      >
        <img src="https://flagcdn.com/w20/ar.png" alt="Español" width="20" height="15" />
      </button>
      
      <button 
        className={`lang-btn ${i18n.language === 'en' ? 'active' : ''}`}
        onClick={() => i18n.changeLanguage('en')}
      >
        <img src="https://flagcdn.com/w20/gb.png" alt="English" width="20" height="15" />
      </button>
    </div>
        

        <Carousel/> 

        <Container fluid className="py-4">
          <Row className="justify-content-center">
            <Col xs={12} md={10} lg={8}>
              <div className="guanteo-descripcion">
                <h2 className='bungee-regular'>{t('titulo')}</h2>
              
               <p>
                  <Trans i18nKey="descripcion" />
                </p>

                 <div className="manual-cta text-center mt-4">
              <p className="mb-3">{t('manual')}</p>
              <Button  size="lg" href="/Manual Cardúmenes.pdf" target="_blank" className="guanteo-btn">
                📖 {t('manualbtn')}
              </Button>
            </div>
              </div>
              
            </Col>
          </Row>
           <Row>
           
          </Row>
     
      </Container>

        <Container>
          <Container className="my-5">
             <h2 className="text-center guanteo-subtitulo mt-5">
        📹 {t('titulovideo')}
      </h2>
    
             <Row className="g-4 justify-content-center">
              <Col xs={12} md={6} lg={4}>
                <GuanteoCard
                  image="Unboxing portada.png"
                  description="Unboxing"
                  videoLink="https://www.youtube.com/watch?v=BnSNdYZrYKs"
                />
              </Col>
              <Col xs={12} md={6} lg={4}>
                <GuanteoCard
                  image="Tutorial Portada.png"
                  description={t('descvideo')}
                  videoLink="https://youtu.be/L_i7XyUP9wI"
                />
               
              </Col>
              {/*<Col xs={12} md={6} lg={4}>
                <GuanteoCard
                  image="logo192.png"
                  description="Consejos avanzados para mejorar tu memoria y usar combos a tu favor."
                  videoLink="https://www.youtube.com/watch?v=video3"
                />
              </Col>*/}
            </Row>
           
          </Container>
      
        <Container fluid className="guanteo-banner mt-5 py-5">
        <Row className="justify-content-center text-center">
          <Col xs={12} md={10} lg={8}>
            <h3 className="guanteo-banner-title mb-4">
               <Trans i18nKey="callactiontitulo" />
            </h3>
            <div className="d-flex justify-content-center flex-wrap gap-3">
              <Button 
                variant="warning" 
                size="lg" 
                href="https://tienda.kitsunegames.ar/producto/cardumenes"
                 target="_blank"
                className="guanteo-banner-btn"
              >
                🛒 {t('callactionbtn1')}
              </Button> 
             
                  <Button 
              variant="outline-light" 
              size="lg" 
              onClick={() => setShowModal(true)}
              className="guanteo-banner-btn"
            >
              🧾 {t('callactionbtn2')}
            </Button>

            <MayoristaModal show={showModal} handleClose={() => setShowModal(false)} />
                  </div>
                </Col>
        </Row>
      </Container>


        <FaqSection />

        <footer className="footer text-white py-4">
  <div className="container">
    <div className="row text-center text-md-start align-items-center">

      {/* Logo y nombre de la editorial */}
      <div className="col-md-3 mb-4 mb-md-0 d-flex flex-column align-items-center">
        <img
          src="Logosnorkel.png"
          alt="Logo Editorial"
          className="footer-editorial-logo mb-2"
        />
       
      </div>

      {/* Nombre del juego y tagline */}
      <div className="col-md-6 mb-4 mb-md-0 text-center">
        <img src="Logo-cardumenes-blanco.png" alt="Logo cardúmenes" className="logo-cardumenes-footer" />
        <p className="mb-2">{t('frasefooter')}</p>
        <div className="social-icons d-flex justify-content-center gap-3">
          <a
            href="https://www.youtube.com/@Kitsunegamesar"
            className="text-white"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaYoutube size={24} />
          </a>
          <a
            href="https://www.instagram.com/kitsunegames.ar/"
            className="text-white"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram size={24} />
          </a>
          <a
            href="https://www.kitsunegames.ar"
            className="text-white"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaGlobe size={24} />
          </a>
        </div>
      </div>

      {/* Leyenda de derechos */}
      <div className="col-md-3 text-center text-md-end">
        <p className="mb-1">© {new Date().getFullYear()} Editorial KitsuneGames</p>
        <p className="mb-0">{t('copiright')}</p>
      </div>
    </div>
  </div>
</footer>


</Container>
       </div>
       
     );
   }
   
   export default Index;